(() => {
  const addNavLink = (section) => {
    const nav = document.querySelector('[data-product-section-nav]');
    if (!nav || nav.querySelector('a[href="#pas-product-related"]')) return;
    const item = document.createElement('li');
    item.innerHTML = '<a href="#pas-product-related">Pairs with<span aria-hidden="true"></span></a>';
    nav.append(item);
    document.dispatchEvent(new CustomEvent('pas:navigation-updated'));
  };

  document.querySelectorAll('[data-related-products]').forEach(async (section) => {
    if (section.querySelector('pas-product-card')) {
      section.hidden = false;
      addNavLink(section);
      document.dispatchEvent(new CustomEvent('pas:cards-rendered'));
      return;
    }

    const url = section.dataset.recommendationsUrl;
    if (!url) return;
    try {
      const response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) return;
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = documentFragment.querySelector('[data-related-products]');
      if (!replacement?.querySelector('pas-product-card')) return;
      section.replaceWith(replacement);
      replacement.hidden = false;
      addNavLink(replacement);
      document.dispatchEvent(new CustomEvent('pas:cards-rendered'));
    } catch {
      /* Recommendations are an enhancement; an empty section stays hidden. */
    }
  });
})();
